import { defineTokens } from '@chakra-ui/react';

const fonts = defineTokens.fonts({
    body: { value: `var(--font-inter, sans-serif)` },
    heading: { value: `var(--font-maison-neue, sans-serif)` },
    mono: { value: `var(--font-maison-neue, monospace)` },
});

export { fonts };
